export const sqDocumentConstants = {
    SQ_DOCUMENT_FETCHING: 'SQ_DOCUMENT_FETCHING',
    SQ_DOCUMENT_FETCHED: 'SQ_DOCUMENT_FETCHED',
    SQ_DOCUMENT_SUBMITTING: 'SQ_DOCUMENT_SUBMITTING',
    SQ_DOCUMENT_SUBMITTED: 'SQ_DOCUMENT_SUBMITTED',
    GET_SQ_DOCUMENT_BY_SQDOCNUM: 'GET_SQ_DOCUMENT_BY_SQDOCNUM'
}